import CompetitionStackMarker from 'components/organisms/competition-stacking/services/competition-stack-marker';
import Const from 'constants';

function createCompetitionKey(opponentKeys) {
    return opponentKeys.sort().join('_');
}

function createSimplexCompetitionKey(opponentKeys) {
    return Const.LP_TEAM_GROUP_PREFIX + CompetitionStackMarker.setSuffix(createCompetitionKey(opponentKeys));
}

export {createCompetitionKey, createSimplexCompetitionKey};
